import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

/** Auth API Store */
import auth from './auth'
/** Common API Store */
import common from './common'
/** Gurudwara Store */
import gurudwara from './gurudwara'
/** Audio Store */
import audio from './audio'
/** Mantra Store */
import mantra from './mantra'
/** Setting Store */
import setting from './setting'
/** Playlist Store */
import playlist from './playlist'
/** Book Store */
import book from './book'
/** Pauri Store */
import pauri from './pauri'
/** Ashtapadi Store */
import ashtapadi from './ashtapadi'
/** Solo Book Store */
import soloBook from './solo-book'
/** Creator Store */
import creator from './creator'
/** Leadership Store */
import leadership from './leadership'
/** Service Store */
import service from './service'
/** Available service (organization / simple service list) */
import availableService from './available-service'
/** Month Store */
import month from './month'
/** Video Store */
import video from './video'
/** guideTutorial Store */
import guideTutorial from './guide-tutorial'
/** Dashboard Store */
import dashboard from './dashboard'
/** Feedback Store */
import feedback from './feedback'
/** Gurudwara Onboard Store */
import gurudwaraOnboard from './gurudwara-onboard'
/** User Store */
import user from './user'
/** Premium Offer Store */
import premiumOffer from './premium-offer'
/** Book Header Store */
import header from './header'
/** AI Store */
import ai from './ai'
/** Organization Store */
import organization from './organization'
import organizationOnboard from './organization-onboard'
import voiceBySangat from './voice-by-sangat'

/** Subscription Plan Store */
import committee from '@/store/committee'
import permission from '@/store/permission'
import restrictedKeyword from '@/store/restricted-keyword'
import role from '@/store/role'
import subscriptionPlan from './subscription-plan'

/** Learning Mode */
import learningMode from './learning-mode'
/** Gurudara Admin Services */
import gurudwaraServices from './gurudwara-services'
/** Hotel Store */
import hotel from './hotel'
import adminNotifications from './adminNotifications'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    common,
    gurudwara,
    hotel,
    audio,
    mantra,
    setting,
    playlist,
    book,
    pauri,
    ashtapadi,
    soloBook,
    creator,
    leadership,
    permission,
    role,
    committee,
    service,
    availableService,
    month,
    video,
    guideTutorial,
    dashboard,
    feedback,
    gurudwaraOnboard,
    user,
    premiumOffer,
    subscriptionPlan,
    restrictedKeyword,
    header,
    ai,
    organization,
    learningMode,
    organizationOnboard,
    gurudwaraServices,
    adminNotifications,
    searchHistory: require('./search-history').default,
    voiceBySangat
  }
})
